// WORKAROUND: Angular doesn't know about autofilled inputs
angular.module('lf.common')

.directive('lfFormAutofillFix', function() {
  return function(scope, elem, attrs) {
    // Fixes Chrome bug: https://groups.google.com/forum/#!topic/angular/6NlucSskQjY
    elem.prop('method', 'POST');

    // Fix autofill issues where Angular doesn't know about autofilled inputs
    if(attrs.ngSubmit) {
      setTimeout(function() {
        elem.unbind('submit').submit(function(e) {
            // e.preventDefault();
            elem.find('input, textarea, select').trigger('input').trigger('change').trigger('keydown');
            scope.$eval(attrs.ngSubmit, { $event: e });
            scope.$digest();
        });
      }, 0);
    }
  };
});
